import { ApiServiceBase, DEFAULT_API_OPTIONS } from "./apiServiceBase";

export class CommonService extends ApiServiceBase {
  constructor({ baseUrl, timeout } = DEFAULT_API_OPTIONS) {
    super({ baseUrl, timeout });
    this._path = "Common";
  } 

  searchMeter(id) {
    return this._axios.get(`${this._path}/meter/${id}`);
  }

  reading(id) {
    return this._axios.get(`${this._path}/Reading/${id}`); 
  }

  getUsages(id,type,beginTime,endTime){
    return this._axios.get(`${this._path}/Usages/${id}?&type=${type}&begin=${beginTime}&end=${endTime}`);
  }
  
  getLogo() {
    return this._axios.get(`${this._path}/GetLogo`); 
  }
}

export const commonService = new CommonService();
